<template>
  <div class="customized-box multi-select">
    <h6 class="title">
      {{ _T('extra instruction') }}
      <span class="optional">({{ _T('optional') }})</span>
    </h6>
    <textarea
      class="form-control"
      id="exampleFormControlTextarea1"
      rows="1"
      v-model="itemNote"
    ></textarea>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ExtraInstruction',
  computed: {
    ...mapGetters(['_T']),
    itemNote: {
      set(val) {
        this.$store.commit('ITEM_NOTE', val)
      },
      get() {
        return this.$store.state.cart_store.itemNote
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.customized-box {
  #exampleFormControlTextarea1 {
    @media (max-width: 575px) {
      min-height: $px90;
      margin-bottom: $px32;
      @media (max-width: 575px) {
        font-size: $px12;
      }
    }
  }
}
</style>
